import type { ReactNode } from 'react';
import { ArrowsLeftRight, Cloud, Stack, UserSwitch } from '@phosphor-icons/react';

import { Widget } from '../blog/Figure';

/**
 * Four things people call an "MCP proxy", for /blog/mcp-proxy-vs-mcp-gateway.
 * It shows the structure of the post's first section so a skimmer sees that
 * the word covers four jobs and none of them is an access decision. Every
 * description is from the named project's or the MCP specification's own
 * page, read 2026-10-15 (sources are linked in the post).
 */

const KINDS: { icon: ReactNode; name: string; job: string; source: string }[] = [
  {
    icon: <ArrowsLeftRight size={22} />,
    name: 'Transport bridge',
    job: 'Exposes a stdio server over HTTP, or an HTTP server over stdio.',
    source: 'FastMCP proxy docs',
  },
  {
    icon: <Stack size={22} />,
    name: 'Aggregator',
    job: 'Mounts several servers behind one, with prefixes such as weather_get_forecast.',
    source: 'FastMCP proxy docs',
  },
  {
    icon: <Cloud size={22} />,
    name: 'Signing proxy',
    job: 'Signs requests to remote servers with AWS SigV4; has a read-only mode.',
    source: 'MCP Proxy for AWS announcement',
  },
  {
    icon: <UserSwitch size={22} />,
    name: 'OAuth proxy server',
    job: 'Fronts a third-party API as a single OAuth client for every MCP client.',
    source: 'MCP security best practices',
  },
];

export function ProxyKinds() {
  return (
    <Widget title="Four jobs that share the word proxy">
      <ul className="bw-in gc-grid">
        {KINDS.map((k) => (
          <li key={k.name}>
            <span className="gc-ico" aria-hidden="true">
              {k.icon}
            </span>
            <div>
              <b>{k.name}</b>
              <p>{k.job}</p>
              <p className="bw-note">Source: {k.source}</p>
            </div>
          </li>
        ))}
      </ul>
    </Widget>
  );
}
